/* eslint-disable @typescript-eslint/no-explicit-any */
export enum MachineTypeSR {
    WorkingMachine = <any>'Radna mašina',
    HandMachine = <any>'Ručna mašina',
    OfficeMachine = <any>'Kancelarijska mašina',
    WorkingTool = <any>'Alat',
}
